import Cookie from '../helpers/Cookie';

;$(function() {

	$('.footer__regions a').click(function(e) {

		e.preventDefault();

		Cookie.set('city_ask', '1', {expires: 7*24*60*60});
		Cookie.set('city', $(this).data('city'), {expires: 7*24*60*60});

		window.location.href = $(this).attr('href');

	});

});